import axios, { AxiosResponse } from "axios";
import { IVehicleTypeModel } from "./VehicleTypeModel";
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const VEHICLE_TYPE_CREATE_URL = `${API_URL}api/v1/definition/vehicleType/create`;
export const VEHICLE_TYPE_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleType/all`;
export const VEHICLE_TYPE_DELETE_URL = `${API_URL}api/v1/definition/vehicleType/delete/`;
export const VEHICLE_TYPE_UPDATE_URL = `${API_URL}api/v1/definition/vehicleType/update/`;



export function createVehicleType(vehicle: IVehicleTypeModel) {
  return axios.post(VEHICLE_TYPE_CREATE_URL, vehicle)
}

export async function loadVehicleTypes(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IVehicleTypeModel>>>> {
  return axios.get(VEHICLE_TYPE_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteVehicleType(vehicleId: String) {
  return axios.delete(VEHICLE_TYPE_DELETE_URL + vehicleId)
}

export function updateVehicleType(vehicle: IVehicleTypeModel) {
  return axios.patch(VEHICLE_TYPE_UPDATE_URL + vehicle.id, vehicle)
}
